<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "DUPLICATE_TAXFILEROUTSIDE_INSIDE_TITLE" | globalTranslate }}
    </h1>
  </div>
  <div class="modal-body">
    <span
      [innerHTML]="'DUPLICATE_TAXFILEROUTSIDE_INSIDE_TEXT_01' | globalTranslate"
    ></span>
    @for (dupIndv of dupIndvs; track dupIndv; let i = $index) {
    <span>
      @if (dupIndvs.length > 1) {
      {{ dupIndv }}
      @if ( i !== dupIndvs.length-1) { @if (i === dupIndvs.length-2) {
      {{ "DUPLICATE_TAXFILEROUTSIDE_INSIDE_AND" | globalTranslate }}
      } @if (i !== dupIndvs.length-2) { , } } } @if (dupIndvs.length === 1) {
      {{ dupIndv }}
      }
    </span>
    } @if (section === 'taxdep') {
    <span
      [innerHTML]="'DUPLICATE_TAXFILEROUTSIDE_INSIDE_TEXT_02' | globalTranslate"
    ></span>
    } @if (section === 'jointfiler') {
    <span
      [innerHTML]="'DUPLICATE_JOINTFILER_INSIDE_TEXT_02' | globalTranslate"
    ></span>
    }
  </div>
  <div class="modal-footer">
    <div class="me-2 ml-2">
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onClosed()"
      >
        {{ "CLOSE" | globalTranslate }}
      </button>
    </div>
  </div>
</div>